import React, { useEffect } from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import LocationFilterModal from './components/LocationFilterModal'
import TabNavigation from '~/components/TabNavigation'
import useCompanies from '@verzekeringapp-mono/shared/src/hooks/use_companies'
import ListView from './components/ListView'
import MapView from './components/MapView'
import { NH_LAT_LNG } from '@verzekeringapp-mono/shared/src/state/constants/constants'

const DamageRepairVehicleScreen = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(true)
  const { getCategories } = useCompanies()
  const [ref, setRef] = React.useState<google.maps.Map | null>(null)
  const [isLoading, setIsLoading] = React.useState(false)
  const [center, setCenter] = React.useState(NH_LAT_LNG)

  useEffect(() => {
    setIsLoading(true)
    getCategories().finally(() => {
      setIsLoading(false)
    })
  }, [])

  useEffect(() => {
    if (ref && center) {
      ref?.panTo({
        lat: center.lat,
        lng: center.lng
      })
    }
  }, [ref, center])

  return (
    <>
      <ScreenWrapper
        hasPadding={false}
        breadCrumbsOverride={[]}
      >
        <TabNavigation
          tabs={[
            {
              name: 'Kaart',
              value: 'map',
              component: (
                <MapView
                  onCenterChanged={setCenter}
                  setMapRef={setRef}
                  setIsFilterModalOpen={setIsModalOpen}
                  center={center}
                />
              )
            },
            {
              name: 'Lijst',
              value: 'list',
              component: <ListView setIsFilterModalOpen={setIsModalOpen} />
            }
          ]}
        />
      </ScreenWrapper>

      {isModalOpen && !isLoading && (
        <LocationFilterModal
          onLocationSelected={location => {
            setCenter({
              lat: parseFloat(location.latitude),
              lng: parseFloat(location.longitude)
            })
          }}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  )
}

export default DamageRepairVehicleScreen
